/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * imgBaseUrl: 图片所在域名地址
 *
 */

let routerMode = "hash";
let imgBaseUrl = "http://192.168.2.109:8080/erp/mobile";
let baseUrl = "https://erptest.helensbar.com/erpapi/";

let filterStores = ["深圳RAMA","总部","线上商城","工程","测试店","支持部门","营销部收款专用","烟草", "基准店", "支持中心", "采购部"];

if (process.env.NODE_ENV == "development") {
  // baseUrl = "https://yerpapi.helensbar.com/";
  // baseUrl = "http://192.168.2.27:9090/"
  imgBaseUrl = "/img/";
} else if (process.env.NODE_ENV == "production") {
  baseUrl = "https://erpapi.helensbar.com/";
  imgBaseUrl = "https://mobile.helensbar.com";
}

export { baseUrl, routerMode, imgBaseUrl, filterStores };
